import script from "./HeroCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./HeroCarousel.vue?vue&type=style&index=0&id=c8b774d0&lang=scss"

const __exports__ = script;

export default __exports__